export default __webpack_public_path__ + "static/media/d34f5a16-74e6-40d7-b9e9-3883c8aaff08.b901f484.jpeg";